export { SignInViewAdaptive as default } from "../../../navigation/ResponsiveScreens";
